import { Component, Inject } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EMPTY } from 'rxjs';
import { getReportTypeLabel, ReportTypeEnum } from '../../../../constants/report.constant';
import { IPostModel } from '../../../../models/post.model';
import { PostService } from '../../../../services/api/post/post.service';
import { LoaderService } from '../../../../services/loader/loader.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

@Component({
    selector: 'app-report-post-popup',
    standalone: false,
    templateUrl: './report-post-popup.component.html',
    styleUrl: './report-post-popup.component.scss',
})
export class ReportPostPopupComponent extends BasePopupComponent {
    protected reportForm = this.fb.group({
        reason: [getReportTypeLabel(ReportTypeEnum.RudeVulgar)],
    });
    protected getReportTypeLabel = getReportTypeLabel;
    protected ReportTypeEnum = ReportTypeEnum;

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: IPostModel,
        protected override dialogRef: MatDialogRef<ReportPostPopupComponent>,
        private fb: NonNullableFormBuilder,
        private loaderService: LoaderService,
        private postService: PostService,
        private dialog: MatDialog,
    ) {
        super(data, dialogRef);
    }

    protected submit(): void {
        const reason = this.reportForm.controls.reason.getRawValue();

        this.loaderService.show();
        this.postService.reportPost(this.data.id, { reason }).subscribe({
            next: () => {
                this.dialogRef.close(true);
            },
            error: (error) => {
                const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                errorPopupConfig.data = {
                    title: `Error`,
                    message: error.error?.message,
                };
                this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                console.error('Error reporting post:', error);
                return EMPTY;
            },
            complete: () => {
                this.loaderService.hide();
            },
        });
    }
}
